// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AcademyRouteImport } from './routes/academy'
import { Route as AccountExecutiveJobsRouteImport } from './routes/account-executive-jobs'
import { Route as AppointmentSettingRouteImport } from './routes/appointment-setting'
import { Route as BdrJobsRouteImport } from './routes/bdr-jobs'
import { Route as BusinessDevelopmentJobsRouteImport } from './routes/business-development-jobs'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EmployerRouteImport } from './routes/employer'
import { Route as EmployerPreviewRouteImport } from './routes/employer-preview'
import { Route as EmployerSignupRouteImport } from './routes/employer-signup'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FindJobsRouteImport } from './routes/find-jobs'
import { Route as ForEmployersRouteImport } from './routes/for-employers'
import { Route as ForSalespeopleRouteImport } from './routes/for-salespeople'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as InvitationPreviewRouteImport } from './routes/invitation-preview'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as MyProfileRouteImport } from './routes/my-profile'
import { Route as PostJobRouteImport } from './routes/post-job'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SalesExecutiveJobsRouteImport } from './routes/sales-executive-jobs'
import { Route as SalesManagerJobsRouteImport } from './routes/sales-manager-jobs'
import { Route as SalesTrainingRouteImport } from './routes/sales-training'
import { Route as SdrJobsRouteImport } from './routes/sdr-jobs'
import { Route as SectorsRouteImport } from './routes/sectors'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TelesalesJobsRouteImport } from './routes/telesales-jobs'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as AdminChar123TabChar125RouteImport } from './routes/admin.{-$tab}'
import { Route as ApplyJobIdRouteImport } from './routes/apply.$jobId'
import { Route as CheckoutThankYouRouteImport } from './routes/checkout_.thank-you'
import { Route as InviteJobIdRouteImport } from './routes/invite.$jobId'
import { Route as JobsJobIdRouteImport } from './routes/jobs.$jobId'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as ProfileIndexRouteImport } from './routes/profile.index'
import { Route as ProfileSlugRouteImport } from './routes/profile.$slug'
import { Route as RolesRefRouteImport } from './routes/roles.$ref'
import { Route as SalesJobsIndexRouteImport } from './routes/sales-jobs.index'
import { Route as SalesJobsLocationRouteImport } from './routes/sales-jobs.$location'
import { Route as WelcomeRefRouteImport } from './routes/welcome.$ref'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AcademyRoute = AcademyRouteImport.update({
            id: '/academy',path: '/academy',getParentRoute: () => rootRouteImport
          })
const AccountExecutiveJobsRoute = AccountExecutiveJobsRouteImport.update({
            id: '/account-executive-jobs',path: '/account-executive-jobs',getParentRoute: () => rootRouteImport
          })
const AppointmentSettingRoute = AppointmentSettingRouteImport.update({
            id: '/appointment-setting',path: '/appointment-setting',getParentRoute: () => rootRouteImport
          })
const BdrJobsRoute = BdrJobsRouteImport.update({
            id: '/bdr-jobs',path: '/bdr-jobs',getParentRoute: () => rootRouteImport
          })
const BusinessDevelopmentJobsRoute = BusinessDevelopmentJobsRouteImport.update({
            id: '/business-development-jobs',path: '/business-development-jobs',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const EmployerRoute = EmployerRouteImport.update({
            id: '/employer',path: '/employer',getParentRoute: () => rootRouteImport
          })
const EmployerPreviewRoute = EmployerPreviewRouteImport.update({
            id: '/employer-preview',path: '/employer-preview',getParentRoute: () => rootRouteImport
          })
const EmployerSignupRoute = EmployerSignupRouteImport.update({
            id: '/employer-signup',path: '/employer-signup',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FindJobsRoute = FindJobsRouteImport.update({
            id: '/find-jobs',path: '/find-jobs',getParentRoute: () => rootRouteImport
          })
const ForEmployersRoute = ForEmployersRouteImport.update({
            id: '/for-employers',path: '/for-employers',getParentRoute: () => rootRouteImport
          })
const ForSalespeopleRoute = ForSalespeopleRouteImport.update({
            id: '/for-salespeople',path: '/for-salespeople',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const InvitationPreviewRoute = InvitationPreviewRouteImport.update({
            id: '/invitation-preview',path: '/invitation-preview',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const MyProfileRoute = MyProfileRouteImport.update({
            id: '/my-profile',path: '/my-profile',getParentRoute: () => rootRouteImport
          })
const PostJobRoute = PostJobRouteImport.update({
            id: '/post-job',path: '/post-job',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SalesExecutiveJobsRoute = SalesExecutiveJobsRouteImport.update({
            id: '/sales-executive-jobs',path: '/sales-executive-jobs',getParentRoute: () => rootRouteImport
          })
const SalesManagerJobsRoute = SalesManagerJobsRouteImport.update({
            id: '/sales-manager-jobs',path: '/sales-manager-jobs',getParentRoute: () => rootRouteImport
          })
const SalesTrainingRoute = SalesTrainingRouteImport.update({
            id: '/sales-training',path: '/sales-training',getParentRoute: () => rootRouteImport
          })
const SdrJobsRoute = SdrJobsRouteImport.update({
            id: '/sdr-jobs',path: '/sdr-jobs',getParentRoute: () => rootRouteImport
          })
const SectorsRoute = SectorsRouteImport.update({
            id: '/sectors',path: '/sectors',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TelesalesJobsRoute = TelesalesJobsRouteImport.update({
            id: '/telesales-jobs',path: '/telesales-jobs',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UpgradeRoute = UpgradeRouteImport.update({
            id: '/upgrade',path: '/upgrade',getParentRoute: () => rootRouteImport
          })
const AdminChar123TabChar125Route = AdminChar123TabChar125RouteImport.update({
            id: '/admin/{-$tab}',path: '/admin/{-$tab}',getParentRoute: () => rootRouteImport
          })
const ApplyJobIdRoute = ApplyJobIdRouteImport.update({
            id: '/apply/$jobId',path: '/apply/$jobId',getParentRoute: () => rootRouteImport
          })
const CheckoutThankYouRoute = CheckoutThankYouRouteImport.update({
            id: '/checkout_/thank-you',path: '/checkout/thank-you',getParentRoute: () => rootRouteImport
          })
const InviteJobIdRoute = InviteJobIdRouteImport.update({
            id: '/invite/$jobId',path: '/invite/$jobId',getParentRoute: () => rootRouteImport
          })
const JobsJobIdRoute = JobsJobIdRouteImport.update({
            id: '/jobs/$jobId',path: '/jobs/$jobId',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const ProfileIndexRoute = ProfileIndexRouteImport.update({
            id: '/profile/',path: '/profile/',getParentRoute: () => rootRouteImport
          })
const ProfileSlugRoute = ProfileSlugRouteImport.update({
            id: '/profile/$slug',path: '/profile/$slug',getParentRoute: () => rootRouteImport
          })
const RolesRefRoute = RolesRefRouteImport.update({
            id: '/roles/$ref',path: '/roles/$ref',getParentRoute: () => rootRouteImport
          })
const SalesJobsIndexRoute = SalesJobsIndexRouteImport.update({
            id: '/sales-jobs/',path: '/sales-jobs/',getParentRoute: () => rootRouteImport
          })
const SalesJobsLocationRoute = SalesJobsLocationRouteImport.update({
            id: '/sales-jobs/$location',path: '/sales-jobs/$location',getParentRoute: () => rootRouteImport
          })
const WelcomeRefRoute = WelcomeRefRouteImport.update({
            id: '/welcome/$ref',path: '/welcome/$ref',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AcademyRoute: AcademyRoute,AccountExecutiveJobsRoute: AccountExecutiveJobsRoute,AppointmentSettingRoute: AppointmentSettingRoute,BdrJobsRoute: BdrJobsRoute,BusinessDevelopmentJobsRoute: BusinessDevelopmentJobsRoute,CheckoutRoute: CheckoutRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRoute,EmployerRoute: EmployerRoute,EmployerPreviewRoute: EmployerPreviewRoute,EmployerSignupRoute: EmployerSignupRoute,FaqRoute: FaqRoute,FindJobsRoute: FindJobsRoute,ForEmployersRoute: ForEmployersRoute,ForSalespeopleRoute: ForSalespeopleRoute,ForgotPasswordRoute: ForgotPasswordRoute,HowItWorksRoute: HowItWorksRoute,InvitationPreviewRoute: InvitationPreviewRoute,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,MyProfileRoute: MyProfileRoute,PostJobRoute: PostJobRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SalesExecutiveJobsRoute: SalesExecutiveJobsRoute,SalesManagerJobsRoute: SalesManagerJobsRoute,SalesTrainingRoute: SalesTrainingRoute,SdrJobsRoute: SdrJobsRoute,SectorsRoute: SectorsRoute,SignupRoute: SignupRoute,TelesalesJobsRoute: TelesalesJobsRoute,TermsRoute: TermsRoute,UpgradeRoute: UpgradeRoute,AdminChar123TabChar125Route: AdminChar123TabChar125Route,ApplyJobIdRoute: ApplyJobIdRoute,CheckoutThankYouRoute: CheckoutThankYouRoute,InviteJobIdRoute: InviteJobIdRoute,JobsJobIdRoute: JobsJobIdRoute,PSlugRoute: PSlugRoute,ProfileSlugRoute: ProfileSlugRoute,RolesRefRoute: RolesRefRoute,SalesJobsLocationRoute: SalesJobsLocationRoute,WelcomeRefRoute: WelcomeRefRoute,ProfileIndexRoute: ProfileIndexRoute,SalesJobsIndexRoute: SalesJobsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)